import { Box } from '@material-ui/core';
import { Shipping } from '@nemuru-eng/js-api-client';

import { shippingMethodOptionsArray } from '@/components/modules/ShippingAndBilling/_shared/components/ShippingDetails/constants/constants';
import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { FormGridOptions } from '@/components/shared/components/FormGridContainer/types/formGridOptions';
import { AutocompleteNationalityFormField } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/AutocompleteNationalityFormField';
import { SelectFormField } from '@/components/shared/components/NewContextForms/SelectFormField';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';

interface ShippingFormProps extends FormGridOptions {
  shipping: Shipping;
}

export const ShippingForm = ({ shipping, fieldVariant, fullWidth }: ShippingFormProps) => {
  return (
    <Box pt={2}>
      <FormGridContainer fieldVariant={fieldVariant} fullWidth={fullWidth}>
        <TextFormField label={'SHIPPING_NAME'} name={'shippingName'} value={shipping.name} />
        <SelectFormField
          name={'shippingMethod'}
          label={'SHIPPING_METHOD'}
          value={shipping.method}
          selectOptions={shippingMethodOptionsArray}
        />
        <TextFormField label={'FIRST_NAME'} name={'firstName'} value={shipping.customer.name.first} />
        <TextFormField label={'LAST_NAME'} name={'lastName'} value={shipping.customer.name.last} />
        <TextFormField label={'EMAIL'} name={'email'} value={shipping.customer.email} />
        <TextFormField label={'PHONE_NUMBER'} name={'phone'} value={shipping.customer.phone} />

        <TextFormField label={'COMPANY_NAME'} name={'companyName'} value={shipping.businessName} />
        <TextFormField label={'STREET_ADDRESS'} name={'streetAddress'} value={shipping.address.streetAddress} />
        <TextFormField label={'STREET_ADDRESS_2'} name={'streetAddress2'} value={shipping.address.streetAddress2} />
        <TextFormField label={'POSTAL_CODE'} name={'postalCode'} value={shipping.address.postalCode} />
        <TextFormField label={'CITY'} name={'city'} value={shipping.address.city} />
        <AutocompleteNationalityFormField value={shipping.address.country} label={'COUNTRY'} name={'country'} />
      </FormGridContainer>
    </Box>
  );
};
